import { useRouter } from 'next/router';

import { IFacetOption } from 'shared/types/ConstructorFacet';
import { SearchFilterLink } from 'search/components/searchGrid/SearchFilterLink';
import { SearchFilterListOption } from 'search/styles/SearchStyles';
import { UnorderedList } from 'shared/components/UnorderedList';
import { getAppliedFilters } from 'shared/utils/gridEventTrackingUtils';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useEventContext } from 'tracking/hooks/useEventContext';
import { getConstructorCategoriesStrings } from 'search/enums/translations';
import { startCase } from 'shared/utils/startCase';

interface ISearchFilterList {
  facetType: string;
  filterOptions: Array<IFacetOption>;
  resultIds: Array<string>;
  isCrawler?: boolean;
}

export const ConsumerSearchFilterList = ({
  name,
  filterOptions,
  handleClick,
}: {
  name: string;
  filterOptions: any;
  handleClick: any;
}) => {
  const eventTrackingEventContext = useEventContext();
  const { query } = useRouter();

  const handleOnClick = (optionValue) => {
    sendTrackingEvent('FILTER_APPLY_TAP', {
      event_context: eventTrackingEventContext,
      filter_name: name,
      filter_selection: optionValue,
      ...(query?.query && { search_string: query?.query?.toString() }),
      ...(getAppliedFilters(query) && { applied_filters: getAppliedFilters(query) }),
    });
    handleClick?.(optionValue);
  };

  return (
    <UnorderedList data-qa="search_filter_list">
      {filterOptions.map((option) => (
        <li key={option.value}>
          <SearchFilterListOption
            data-qa={`${option.value}_filter_option`}
            $isSelected={option.status === 'selected'}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleOnClick(option.value);
            }}
          >
            {startCase(getConstructorCategoriesStrings(option.display_name as string))}
          </SearchFilterListOption>
        </li>
      ))}
    </UnorderedList>
  );
};

export const SearchFilterList = ({
  facetType,
  filterOptions,
  resultIds,
  isCrawler = false,
}: ISearchFilterList) => {
  const eventTrackingEventContext = useEventContext();
  const { query } = useRouter();

  const handleOnClick = (optionValue) => {
    sendTrackingEvent('FILTER_APPLY_TAP', {
      event_context: eventTrackingEventContext,
      filter_name: facetType,
      filter_selection: optionValue,
      result_id: resultIds[0],
      ...(query?.query && { search_string: query?.query?.toString() }),
      ...(getAppliedFilters(query) && { applied_filters: getAppliedFilters(query) }),
    });
  };

  return (
    <UnorderedList data-qa="search_filter_list">
      {filterOptions.map((option) => (
        <li key={option.value}>
          <SearchFilterLink facetType={facetType} option={option} isCrawler={isCrawler}>
            <SearchFilterListOption
              data-qa={`${option.value}_filter_option`}
              $isSelected={option.status === 'selected'}
              onClick={() => handleOnClick(option.value)}
            >
              {startCase(getConstructorCategoriesStrings(option.display_name))}
            </SearchFilterListOption>
          </SearchFilterLink>
        </li>
      ))}
    </UnorderedList>
  );
};
